var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('gl-alert',{attrs:{"variant":"danger"},on:{"dismiss":function($event){_vm.error = ''}}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('work-item-detail',{attrs:{"work-item-iid":_vm.iid},on:{"deleteWorkItem":function($event){return _vm.deleteWorkItem($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }